import classNames from 'classnames';
import Hammer, { Manager } from 'hammerjs';
import React, { useState, useRef, useCallback, useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom';
// import Icon from '../icon';
import { createPrefixCls } from '../_utils/string';
import toast from '../toast';
const prefixCls = createPrefixCls('upload');
export const Copper = ({ imgUrl, onCancel, onDone }) => {
    const defaultPosition = useRef({
        left: 0,
        top: 0
    });
    const defaultSize = useRef({
        width: 0,
        height: 0
    });
    const [positionStyle, setPositionStyle] = useState({ top: 0, left: 0 });
    const [sizeStyle, setSizeStyle] = useState({
        width: 0,
        height: 0
    });
    // const [rotate, setRotate] = useState<number>(0);
    const $img = useRef();
    const $grid = useRef();
    const $mc = useRef(Manager);
    useEffect(() => {
        if ($img.current) {
            $img.current.onload = () => {
                if ($img.current && $grid.current) {
                    const { height: gridHeight } = $grid.current.getBoundingClientRect();
                    const { width: imgWidth, height: imgHight } = $img.current.getBoundingClientRect();
                    const top = (gridHeight - imgHight) / 2;
                    const left = 0;
                    defaultPosition.current = { top, left };
                    defaultSize.current = { width: imgWidth, height: imgHight };
                    setPositionStyle({
                        top,
                        left
                    });
                    setSizeStyle({ width: imgWidth, height: imgHight });
                }
            };
        }
    }, []);
    const getValidPosition = useCallback(({ currentTop, currentLeft }) => {
        if ($img.current && $grid.current) {
            const { width: gridWidth, height: gridHeight } = $grid.current.getBoundingClientRect();
            const { width: imgWidth, height: imgHeight } = $img.current.getBoundingClientRect();
            const minLeft = gridWidth > imgWidth ? (gridWidth - imgWidth) / 2 : gridWidth - imgWidth;
            const maxLeft = Math.max(minLeft, 0);
            const minTop = gridHeight > imgHeight ? (gridHeight - imgHeight) / 2 : gridHeight - imgHeight;
            const maxTop = Math.max(minTop, 0);
            let finalTop;
            let finalLeft;
            if (currentTop > maxTop) {
                finalTop = maxTop;
            }
            else if (currentTop < minTop) {
                finalTop = minTop;
            }
            else {
                finalTop = currentTop;
            }
            if (currentLeft > maxLeft) {
                finalLeft = maxLeft;
            }
            else if (currentLeft < minLeft) {
                finalLeft = minLeft;
            }
            else {
                finalLeft = currentLeft;
            }
            return {
                top: finalTop,
                left: finalLeft
            };
        }
        else {
            return {
                top: 0,
                left: 0
            };
        }
    }, []);
    const updateImgDomPosition = useCallback(({ top, left }) => {
        if ($img.current) {
            $img.current.style.transform = `translate(${left}px, ${top}px)`;
        }
    }, []);
    useEffect(() => {
        if ($img.current) {
            if ($mc.current) {
                $mc.current.destroy();
            }
            $mc.current = new Hammer.Manager($img.current);
            const pinch = new Hammer.Pinch({ threshold: 0 });
            const pan = new Hammer.Pan({ threshold: 0 });
            $mc.current.add([pinch, pan]);
            let startWidth;
            let startHeight;
            $mc.current.on('pinchstart', () => {
                if ($img.current) {
                    startWidth = sizeStyle.width;
                    startHeight = sizeStyle.height;
                }
            });
            $mc.current.on('pinchmove', (ev) => {
                if ($img.current) {
                    $img.current.style.width = `${startWidth * ev.scale}px`;
                    const top = ev.center.y - ev.scale * (ev.center.y - positionStyle.top);
                    const left = ev.center.x - ev.scale * (ev.center.x - positionStyle.left);
                    updateImgDomPosition({
                        top,
                        left
                    });
                }
            });
            $mc.current.on('pinchend', (ev) => {
                if ($img.current) {
                    const width = Math.max(startWidth * ev.scale, defaultSize.current.width);
                    const height = Math.max(startHeight * ev.scale, defaultSize.current.height);
                    $img.current.style.width = `${width}px`;
                    const currentTop = ev.center.y - ev.scale * (ev.center.y - positionStyle.top);
                    const currentLeft = ev.center.x - ev.scale * (ev.center.x - positionStyle.left);
                    const { top, left } = getValidPosition({ currentTop, currentLeft });
                    updateImgDomPosition({
                        top,
                        left
                    });
                    setSizeStyle({ width, height });
                    setPositionStyle({
                        top,
                        left
                    });
                }
            });
            let startTop = 0;
            let startLeft = 0;
            $mc.current.on('panstart', () => {
                if ($img.current) {
                    startTop = positionStyle.top;
                    startLeft = positionStyle.left;
                }
            });
            $mc.current.on('panmove', (ev) => {
                if ($img.current) {
                    updateImgDomPosition({
                        top: startTop + ev.deltaY,
                        left: startLeft + ev.deltaX
                    });
                }
            });
            $mc.current.on('panend', (ev) => {
                if ($img.current && $grid.current) {
                    const currentTop = startTop + ev.deltaY;
                    const currentLeft = startLeft + ev.deltaX;
                    const { top, left } = getValidPosition({ currentTop, currentLeft });
                    updateImgDomPosition({
                        top,
                        left
                    });
                    setPositionStyle({
                        top,
                        left
                    });
                }
            });
        }
    }, [
        getValidPosition,
        positionStyle.left,
        positionStyle.top,
        sizeStyle.height,
        sizeStyle.width,
        updateImgDomPosition
    ]);
    // const handleRotate = useCallback(() => {
    //   if (rotate < 270) {
    //     setRotate(rotate + 90);
    //   } else {
    //     setRotate(0);
    //   }
    // }, [rotate]);
    const handleCancel = useCallback(() => {
        onCancel && onCancel();
    }, [onCancel]);
    const handleReset = useCallback(() => {
        setSizeStyle(Object.assign({}, defaultSize.current));
        setPositionStyle(Object.assign({}, defaultPosition.current));
        // setRotate(0);
    }, []);
    const handleDone = useCallback(() => {
        if (imgUrl && $grid.current) {
            toast.showLoading('上传中，请稍后...');
            const { width: gridWidth, height: gridHeight } = $grid.current.getBoundingClientRect();
            const cvs = document.createElement('canvas');
            cvs.style.position = 'fixed';
            cvs.style.zIndex = '9999';
            cvs.style.top = '0';
            cvs.width = gridWidth;
            cvs.height = gridHeight;
            const ctx = cvs.getContext('2d');
            if (ctx) {
                const img = document.createElement('img');
                img.src = imgUrl;
                img.onload = () => {
                    ctx.drawImage(img, positionStyle.left, positionStyle.top, sizeStyle.width || 0, sizeStyle.height || 0);
                    const imgBase64 = cvs.toDataURL();
                    onDone(imgBase64);
                    toast.hideLoading();
                };
            }
        }
    }, [imgUrl, onDone, positionStyle.left, positionStyle.top, sizeStyle]);
    const isChanged = useMemo(() => {
        return (sizeStyle.width !== defaultSize.current.width ||
            positionStyle.top !== defaultPosition.current.top ||
            positionStyle.left !== defaultPosition.current.left);
    }, [positionStyle.left, positionStyle.top, sizeStyle.width]);
    return ReactDOM.createPortal(React.createElement("div", { className: prefixCls('cropper') },
        React.createElement("div", { ref: $grid, className: prefixCls('grid') },
            React.createElement("div", { className: prefixCls('mask') }),
            React.createElement("img", { ref: $img, className: prefixCls('img'), src: imgUrl, style: Object.assign(Object.assign({}, setSizeStyle), { transform: `translate(${positionStyle.left}px, ${positionStyle.top}px)` }) }),
            [1, 2, 3, 4, 5, 6, 7, 8].map((el) => {
                return React.createElement("div", { key: el, className: classNames(prefixCls('grid-line'), prefixCls(`grid-line-${el}`)) });
            }),
            [1, 2, 3, 4].map((el) => {
                return React.createElement("div", { key: el, className: classNames(prefixCls('grid-corner'), prefixCls(`grid-corner-${el}`)) });
            })),
        React.createElement("div", { className: prefixCls('footer') },
            React.createElement("div", { className: prefixCls('cancel'), onClick: handleCancel }, "\u53D6\u6D88"),
            React.createElement("div", { className: classNames(prefixCls('reset'), !isChanged && prefixCls('disabled')), onClick: handleReset }, "\u8FD8\u539F"),
            React.createElement("div", { className: prefixCls('done'), onClick: handleDone }, "\u5B8C\u6210"))), document.body);
};
export default Copper;
